/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { useTranslation } from "react-i18next";
//Foundation libraries
import { useSite } from "../../../_foundation/hooks/useSite";
//import { PriceDisplay } from "@hcl-commerce-store-sdk/react-component";
import { PriceDisplay } from "../price-display"
//
import { CommerceEnvironment } from "../../../constants/common";

/**
 * Formatted Price or Price Range Display component
 * displays a price or price range between min price to max price that is formatted to the currency and locale or show price pending if price is not available
 */
const FormattedPriceDisplay = (props: any) => {
  const { mySite } = useSite();
  const { i18n } = useTranslation();
  const min = props.min;
  const max = props.max ? props.max : null;
  let currency = props.currency
    ? props.currency
    : mySite
    ? mySite.defaultCurrencyID
    : "";

  const { t } = useTranslation();
  const pendingPriceMessage = t("PriceDisplay.Labels.Pending");
  const noPriceInCurrencyMessage = t("PriceDisplay.Labels.NoPriceInCurrency");
  const language = i18n.languages[0];

  currency = CommerceEnvironment.customEURCurrency.some(e => e === currency) ? "EUR" : currency;

  const message = props.otherCurrency && props.otherCurrency === true? noPriceInCurrencyMessage: pendingPriceMessage;

  return <PriceDisplay {...{ min, max, currency, message, language }} />;
};

export default FormattedPriceDisplay;
